// components/favorite-stations/favorite-stations.component.jsx
import React, { useEffect, useState } from "react";
import { db, updateUser } from "../../firebase/firebase.utils";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { GiStarsStack } from "react-icons/gi";
import { BsPinAngleFill } from "react-icons/bs";

import "./favorite-stations.styles.scss";

const FavoriteStations = () => {
  const currentUser = useSelector((state) => state.user.currentUser);
  const [favoriteStations, setFavoriteStations] = useState([]);

  useEffect(() => {
    if (!currentUser) return;
    const { favoriteStations } = currentUser;
    db.collection("users")
      .doc(currentUser.uid)
      .onSnapshot((userData) => {
        const user = userData.data();
        if (userData.exists) {
          setFavoriteStations(user.favoriteStations);
        }
      });
    // but dose it exists ?
    favoriteStations?.map((station) => {
      db.collection("space")
        .doc(station.fromSpaceId)
        .collection("stations")
        .doc(station.stationId)
        .get()
        .then((stationData) => {
          if (stationData.exists) {
            console.log("well it exists, no code (write somethign)");
          } else {
            console.log(
              "it dose not exist, need to delete from favorite",
              station.stationId,
            );
            db.collection("users")
              .doc(currentUser.uid)
              .get()
              .then((userData) => {
                let user = userData.data();
                user.favoriteStations = user.favoriteStations.filter(
                  (st) => st.stationId !== station.stationId,
                );
                updateUser(currentUser.uid, user);
              });
          }
        });
    });
  }, [currentUser]);
  return (
    <div className="favoriteStations">
      <div className="favPin_header">
        <div className="favPin_icon">
          <BsPinAngleFill size="1em" />
        </div>
        <strong className="pinned_HeaderText">Pinned Projects</strong>
      </div>
      <div className="favoriteStation">
        {favoriteStations?.length === 0 ? (
          <div className="fs__noStar">
            <GiStarsStack size="4em" />
            <p>
              No pinned <br /> projects.
            </p>
          </div>
        ) : (
          <>
            {favoriteStations?.map((station) => {
              const { fromSpaceId, stationId } = station;
              return (
                <div className="fs__item" key={station.stationId}>
                  <Link to={`/s/${fromSpaceId}/e/${stationId}/b`}>
                    <button>
                      {station.emojicon} {station.name}
                    </button>
                  </Link>
                </div>
              );
            })}
          </>
        )}
      </div>
    </div>
  );
};

export default FavoriteStations;
